import { render } from "./SetFaultPage.vue?vue&type=template&id=39151c9e"
import script from "./SetFaultPage.vue?vue&type=script&lang=js"
export * from "./SetFaultPage.vue?vue&type=script&lang=js"

import "./SetFaultPage.vue?vue&type=style&index=0&id=39151c9e&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__